export { version } from './src/package.js'
import { ajaxchain } from './src/ajaxchain.js'

if (typeof jQuery != 'undefined') {
  jQuery.extend(jQuery, {
    ajaxchain: ajaxchain
  })
}
